const config = require("../config")

module.exports = {
    // 获取种植品类列表
    getCropHierarchy: {
        url: config.base_new_url + "get_crop_hierarchy",
        type: "get",
    },
    // 获取小品种对应列表
    getVarietiesByCrop: {
        url: config.base_new_url + "questionnaire/farmer_crop_pheno",
        type: "get",
    },
    // 录入用户权属信息
    addPlotInfo: {
        url: config.base_new_url + "add_plot_info",
        type: "post",
    },
    // 品类列表
    getCrops: {
        url: config.base_new_url + "questionnaire/crops",
        type: "get",
    },
    // 农机设备列表（农户用）
    getMachines: {
        url: config.base_new_url + "questionnaire/farmer_crop_detail",
        type: "get",
    },
    // 问卷-品类对应农事列表
    getCropTasks: {
        url: config.base_new_url + "questionnaire/farm_tasks",
        type: "get",
    },
}